import React from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import Radium from 'radium';
import Styles from './styles';

const SelectableListItem = (props) => {
  const children = props.children;

  return (
    <div
      style={[
        Styles.wrapper,
        props.style,
        props.selected ? { ...Styles.selected, ...props.selectedStyle } : {},
      ]}
      onClick={props.onClick}
      role="presentation"
    >
      {props.icon !== null && <span className={props.icon} style={Styles.icon} />}
      <span style={Styles.text}>{children}</span>
      {props.secondaryIcon !== null && <span className={props.secondaryIcon} style={Styles.icon} />}
    </div>
  );
};

SelectableListItem.propTypes = {
  icon: PropTypes.string,
  secondaryIcon: PropTypes.string,
  style: StylePropType,
  selectedStyle: StylePropType,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
};

SelectableListItem.defaultProps = {
  icon: null,
  secondaryIcon: null,
  style: {},
  selectedStyle: {},
  children: null,
  selected: false,
  onClick: () => {},
};

export default Radium(SelectableListItem);



// WEBPACK FOOTER //
// ./src/components/SelectableListItem/index.js